module.exports = __webpack_public_path__ + "media/contract/Contract-2-3c1a25eb.jpeg";